import { Link } from 'react-router-dom';
import { relatedArticles } from '@/mocks/article';

export default function RelatedArticles() {
  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-8">
          相关爆料
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {relatedArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group cursor-pointer bg-white rounded-lg overflow-hidden transition-transform duration-200 group-hover:-translate-y-1"
            >
              <div className="relative w-full h-40 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 吃瓜网站线路一`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 leading-snug line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.time}</span>
                  <span className="text-xs text-primary-500 font-medium">{article.heat}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}